export default "__VITE_ASSET__t8PNzp4R__"